/**
 * DisplayTestCases component is used to fetch and display the test cases for a programming activity.
 * It includes an accordion to toggle the visibility of the test cases and uses tabs to switch 
 * between visible and hidden test cases.
 */

import log from "loglevel";
import React, { useState, useEffect } from "react";
//import Table from "react-bootstrap/Table";
import { IoMdDownload } from "react-icons/io";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Accordion, Card, Tabs, Tab } from "react-bootstrap";
import "../Loading Spinner/spinner.css";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "Screens1/Student/Course/Content/Programming/ComponentsNew/Testcase/TestCase.css"

const DisplayTestCases = ({ programId, testcasesData = null }) => {
  //State for storing testcases
  const [testcases, setTestcases] = useState(testcasesData || {});
  //State for managing the accordion open and close
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  // Update testcases when parent provides data
  useEffect(() => {
    if (testcasesData) {
      setTestcases(testcasesData);
    }
  }, [testcasesData]);

  const testcasesExportHandler = async (url, testcaseName) => {
    // testcases export handler
    const FileDownload = require("js-file-download");
    try {
        const response = await httpService.instance({
            url,
            method: "GET",
            responseType: "blob", // blob is used to download the file
        });
        FileDownload(response.data, testcaseName);
    } catch (error) {
        log.log(error);
    }
  };
  
  const showTable = (type) =>{
    return (
      <TableContainer component={Paper} sx={{ backgroundColor: 'white' }}>
        <Table
          sx={{
            minWidth: 650,
            backgroundColor: 'white',
            '& .MuiTableCell-root': {
              backgroundColor: 'white',
            },
            '& .MuiTableHead-root .MuiTableCell-root': {
              fontWeight: 'bold',
            },
          }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Input</TableCell>
              <TableCell align="center">Expected Output</TableCell>
              <TableCell align="center">Maximum Marks</TableCell>
              <TableCell align="center">
                <OverlayTrigger overlay={<Tooltip>Download All Testcase</Tooltip>}>
                  <a
                    onClick={() =>
                      testcasesExportHandler(
                        constants.base_url +
                          "/evalpro/program/export_archive/testcases/" +
                          programId,
                        "Testcases.zip"
                      )
                    }
                  >
                    {" "}
                    Download
                  </a>
                </OverlayTrigger>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testcases?.[type]?.map((testcase, i) => (
              <TableRow
                key={testcase.id}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  backgroundColor: 'white',
                }}
              >
                <TableCell align="center">
                  {i + 1}
                </TableCell>

                <TableCell align="center">
                  {testcase.name || '-'}
                </TableCell>

                <TableCell align="left">
                  <div className='m-2'>
                    <code className='code'>
                      {testcase.input || 'Input...'}
                    </code>
                  </div>
                </TableCell>
      
                <TableCell align="left">
                  <div className='m-2'>
                    <code className='code'>
                      {testcase.output || 'Output...'}
                    </code>
                  </div>
                </TableCell>

                <TableCell align="center">
                  {testcase.marks || '1'}
                </TableCell>
      
                <TableCell align="center">
                  <OverlayTrigger
                    overlay={<Tooltip>Download Testcase {i + 1}</Tooltip>}
                  >
                    <a
                      onClick={() =>
                        testcasesExportHandler(
                          `${constants.base_url}/evalpro/testcase/export_archive/${testcase.id}`,
                          `testcase${i + 1}`
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <IoMdDownload size="20" />
                    </a>
                  </OverlayTrigger>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <div>
      <Accordion>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>See Testcases Here</div>
              <div>
                {isAccordionOpen ? (
                  <RiArrowDropDownLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                ) : (
                  <RiArrowDropRightLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse in={isAccordionOpen}>
            <Card.Body>
              <Tabs
                defaultActiveKey="visibletestcases"
                id="uncontrolled-tab-example"
              >
                <Tab eventKey="visibletestcases" title="Practice Testcases">
                  <br />
                  {testcases.visible_testcases?.length > 0 ? (
                    showTable("visible_testcases")
                  ) : (
                    <p style={{ color: "red" }}>
                      Testcases not configured
                    </p>
                  )}
                </Tab>
                <Tab eventKey="hiddentestcases" title="Evaluation Testcases">
                  <br />
                  {testcases.hidden_testcases ? (
                    showTable("hidden_testcases")
                  ) : (
                    <p style={{ color: "red" }}>
                      Hidden test cases will be displayed only after the deadline has passed or when the instructor enables them.
                    </p>
                  )}
                </Tab>
              </Tabs>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default DisplayTestCases;
